export default "__VITE_ASSET__DzmkXfpn__"